// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__liug-","choiceBoxes":"toolbarselects_choiceBoxes__2Z4sC","simpleField":"toolbarselects_simpleField__zP771"};